import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { VersioningGet } from '../../services';

export const fetchVersioningGet = createAsyncThunk(
    'versioningGet/fetchVersioningGet',
    async () => {
        const response = await VersioningGet()
        return response.result
    }
);

const versioningGetSlice = createSlice({
    name: 'versioningGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVersioningGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchVersioningGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchVersioningGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default versioningGetSlice.reducer;
